'use client';

import type { HeaderConfig, ReceiptSettings } from '@/lib/templates/schema';
import { SectionDivider } from './SectionDivider';

interface HeaderSectionProps {
  config: HeaderConfig;
  settings: ReceiptSettings;
}

export function HeaderSection({ config, settings }: HeaderSectionProps) {
  const alignmentClass = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
  }[config.alignment];

  // Use uploaded logo data if available, otherwise fall back to URL
  const logoSrc = config.logoData || config.logoUrl;
  const isNarrow = settings.spacing === 'narrow';

  return (
    <div className={`receipt-section ${alignmentClass}`}>
      {/* Logo - Always centered */}
      {logoSrc && (
        <div className={`${isNarrow ? 'mb-0.5' : 'mb-2'} flex justify-center`}>
          <img
            src={logoSrc}
            alt={config.businessName}
            style={{ 
              width: `${config.logoWidth}px`,
              height: 'auto',
              maxWidth: '100%',
            }}
            className="receipt-logo"
          />
        </div>
      )}

      {/* Business Name */}
      {config.businessName && (
        <div
          className={`font-bold tracking-wider whitespace-pre ${isNarrow ? '' : 'mb-1'}`}
          style={{ 
            fontSize: config.businessNameFontSize,
            fontFamily: settings.font,
          }}
        >
          {config.businessName}
        </div>
      )}

      {/* Address Lines */}
      {config.addressLines.length > 0 && (
        <div className={isNarrow ? '' : 'space-y-0.5'} style={{ lineHeight: isNarrow ? 1.1 : 1.4 }}>
          {config.addressLines.map((line, index) => (
            <div
              key={index}
              className="whitespace-pre"
              style={{ 
                fontSize: settings.fontSize,
                fontFamily: settings.font,
              }}
            >
              {line}
            </div>
          ))}
        </div>
      )}

      {/* Divider */}
      {config.showDivider && (
        <SectionDivider style={config.dividerStyle} settings={settings} />
      )}
    </div>
  );
}

